import actionTypes from "../actionTypes";

const changeLanguage = (langIsoCode) => {
  return {
    type: actionTypes.settings.CHANGE_LANGUAGE,
    langIsoCode: langIsoCode
  };
}

export const settingsActions = {
  changeLanguage
};